import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IProductsResponse } from '../models/products.model';

export const loadProducts = createAction('[Products] Load Static Data Products');

export const loadProductsSuccess = createAction('[Products] Load Static Data Products Success', props<{ response: IProductsResponse[] }>());

export const loadProductsFailure = createAction(
  '[Products] Load Static Data Products Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
